module.exports = __webpack_public_path__ + "img/popup-game-sucai.d37140c3.png";